
@if(displaySideBar){
<p-drawer styleClass="u ui-sidebar-lg" [style]="{ 'width': 'auto', 'max-width': '500px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%'}" 
[(visible)]="displaySideBar" (onHide)="onClickClose(false)" position="right" [baseZIndex]="10000" appendTo="body">
<form #editFdid="ngForm" (ngSubmit)="onUpdate(editFdid)">
    <div class="ui-grid ui-grid-responsive ui-fluid">
        @if(FDIDDetails){
        <div>
            <h3 class="ui-grid-col-12 textSize">Edit FDID Details</h3>
            <div class="ui-grid-col-12 mt-1">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="CatReporterIMID">CatReporterIMID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input type="text" id="ip_fdid_catReporterIMID" name="catReporterIMID" [(ngModel)]="FDIDDetails.catReporterIMID" disabled />
                </div>
            </div>
            <div class="ui-grid-col-12 mt-1">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="AccountNumber">Account Number <span class="required-asterisk">*</span></label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_accountNumber" type="text" name="accountNumber" [(ngModel)]="FDIDDetails.accountNumber" (ngModelChange)="onKeyFieldChanges()"
                     required #accountNumber="ngModel" [class.invalid-field]="accountNumber.invalid && (accountNumber.touched || accountNumber.dirty)"/>
                </div>
            </div>
            <div class="ui-grid-col-12 mt-1">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="Name">Name <span class="required-asterisk">*</span></label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_name" type="text" name="name" [(ngModel)]="FDIDDetails.name" (ngModelChange)="onKeyFieldChanges()"
                     required #name="ngModel" [class.invalid-field]="name.invalid && (name.touched || name.dirty)"/>
                </div>
            </div>
            <div class="ui-grid-col-12 mt-1">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GivenName">Given Name <span class="required-asterisk">*</span></label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_givenname" type="text" name="givenName" [(ngModel)]="FDIDDetails.givenName" (ngModelChange)="onKeyFieldChanges()"
                     required #givenName="ngModel" [class.invalid-field]="givenName.invalid && (givenName.touched || givenName.dirty)"/>
                </div>
            </div>
                
            <div class="ui-grid-col-12 mt-1">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="ReceivedFDID">Received FDID <span class="required-asterisk">*</span></label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_receivedfdid" type="text" name="receivedFDID" [(ngModel)]="FDIDDetails.receivedFDID" (ngModelChange)="onReceivedFDIDChange($event)"
                     required #receivedFDID="ngModel" [class.invalid-field]="receivedFDID.invalid && (receivedFDID.touched || receivedFDID.dirty)"/>
                </div>
            </div>
            <div class="ui-grid-col-12 mt-1">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GeneratedFDID">Generated FDID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_generatedFDID" type="text" name="generatedFDID" [(ngModel)]="FDIDDetails.generatedFDID" disabled />
                </div>
            </div>
                      
            <div class="ui-grid-col-12 buttonStyle mt-2">
                <button pButton type="button" (click)="onClickClose(false)" label="Close"
                    class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionButton"></button>
                <button pButton label="Save" type="submit"
                    class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionButton"></button>
            </div>
        </div>}
    </div>
    </form>
</p-drawer>
}